export const host ="https://e-comerce-node.vercel.app";
export const userRoute=`${host}/user`;
export const adminRoute=`${host}/admin`;
export const siginUp =`${userRoute}/signUp`
export const verified =`${userRoute}/verifiedEmail`
export const resend =`${userRoute}/resendEmail`
export const signIn =`${userRoute}/signIn`
export const updateChange =`${userRoute}/update`
export const adminSiginUp =`${adminRoute}/signup`
export const adminLogin =`${adminRoute}/login`
export const checkout=`${userRoute}/checkout`
export const sendmessage=`${adminRoute}/sendmessage`

